import { render, staticRenderFns } from "./startseite-projektmanagement-6.vue?vue&type=template&id=baf03bca&"
import script from "./startseite-projektmanagement-6.vue?vue&type=script&lang=js&"
export * from "./startseite-projektmanagement-6.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports